import { UPDATE_AWARDING_RULE, RESET_AWARDING_RULE } from './awardingRule.actions';
import {
    AdminSidePanelAction,
    SortOrderType,
    DataviewFieldDataType,
} from '../../../Enums';

export const DEFAULT_DATAVIEW_FIELD_PARAMETER = {
    sortOrderType: SortOrderType.Ascending,
    dataviewKeyAlias: '',
    dataType: DataviewFieldDataType.Numeric,
    customDateFormatId: undefined,
};

/** @type {AwardingRule.IAwardingRuleDetails} */
const initialState = {
    ruleSetId: -1,
    name: '',
    description: '',
    dataviewId: -1,
    parameters: [DEFAULT_DATAVIEW_FIELD_PARAMETER],
    isUsed: false,
    adminSidePanelAction: AdminSidePanelAction.None,
};

/**
 * @param {AwardingRule.IAwardingRuleDetails} state
 * @param {ShiftBidding.IAction} action
 * */
// eslint-disable-next-line default-param-last
export default function adminAwardingRuleReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case UPDATE_AWARDING_RULE:
            return {
                ...state,
                ...payload,
            };
        case RESET_AWARDING_RULE:
            return {
                ...initialState,
            };
        default:
            return state;
    }
}
